import { AxiosResponse } from "axios";
import axiosInstance from "../core/axios";
import { apiEndPoints } from "../variables/apiEndpoints";
import { ClientReportType, ClientType } from "../types/genericType";

export const getAllClients = async (): Promise<ClientType[]> => {
  try {
    const response: AxiosResponse<ClientType[]> = await axiosInstance.get(
      apiEndPoints.investors
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getClientById = async (id: string): Promise<ClientType> => {
  try {
    const response: AxiosResponse<ClientType> = await axiosInstance.get(
      `${apiEndPoints.investors}/${id}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createClient = async (data: ClientType): Promise<ClientType> => {
  try {
    const response: AxiosResponse<ClientType> = await axiosInstance.post(
      apiEndPoints.investors,
      data
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const editClient = async (data: ClientType): Promise<ClientType> => {
  try {
    const response: AxiosResponse<ClientType> = await axiosInstance.put(
      `${apiEndPoints.investors}/${data.id}`,
      data
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getClientReportDetails = async (): Promise<ClientReportType[]> => {
  try {
    const response: AxiosResponse<ClientReportType[]> = await axiosInstance.get(
      `/reports${apiEndPoints.clientDetails}`
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

